/**
 * 超级管理员标识（与后端内置账号/角色编码保持一致）。
 * 判断当前登录用户是否为超管：请统一使用 Pinia `usePermissionStore().isSuperAdmin()`，勿散落硬编码。
 */
export const BUILT_IN_SUPER_ADMIN_ACCOUNT = 'superAdmin'
/** 保持兼容：供角色显示等模块直接引用 */
export const BUILT_IN_SUPER_ADMIN_ROLE_CODE = 'superAdmin'

/** 用户管理：角色 Tab / 菜单 Tab 按钮权限码（与后台按钮配置一致） */
export const PERM_USER_ROLE_TAB = 'user_role_tab'
export const PERM_USER_MENU_TAB = 'user_menu_tab'

/** 兼容“系统管理员”等内置账号（不区分大小写） */
const BUILT_IN_SUPER_ADMIN_ACCOUNT_ALIASES = ['superAdmin', 'admin']

/** 兼容“系统管理员”等内置角色编码（不区分大小写） */
const BUILT_IN_SUPER_ADMIN_ROLE_CODE_ALIASES = ['superAdmin', 'admin', 'SUPER_ADMIN']

function normalizeCode(value: string | undefined | null): string {
  return (value ?? '').trim().toLowerCase()
}

/** 是否为内置超管账号 superAdmin（不含 admin 等别名） */
export function isBuiltInSuperAdminAccount(account: string | undefined | null): boolean {
  return normalizeCode(account) === normalizeCode(BUILT_IN_SUPER_ADMIN_ACCOUNT)
}

/** 登录用户是否为超管：内置超管账号，或拥有超管角色编码 */
export function isLoginSuperAdmin(
  account: string | undefined | null,
  roleCodeSet: Set<string>,
): boolean {
  const accountCode = normalizeCode(account)
  if (
    accountCode &&
    BUILT_IN_SUPER_ADMIN_ACCOUNT_ALIASES.some((x) => normalizeCode(x) === accountCode)
  ) {
    return true
  }
  if (!roleCodeSet.size) return false
  const roleCodeAliases = new Set(BUILT_IN_SUPER_ADMIN_ROLE_CODE_ALIASES.map(normalizeCode))
  for (const roleCode of roleCodeSet) {
    if (roleCodeAliases.has(normalizeCode(roleCode))) return true
  }
  return false
}
